// removed by extract-text-webpack-plugin
module.exports = {"slate":"color__slate___3Hq6C c-slate","white":"color__white___1yq05 c-white"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/Button/style/color.css
// module id = 114
// module chunks = 0 2